/*
 * React counterpart of vanilla/ui/shared/confirmAccountNameNotDuplicate.js
 * Pure function, no DOM — uses React ConfirmAlertHost via confirmAlert.
 */
import { ClientService } from '@vanilla/services/ClientService.js';
import { confirmAlert } from './confirmAlert.js';

export async function confirmAccountNameNotDuplicate(name, options = {}) {
  const trimmed = String(name || '').trim();
  if (!trimmed) return true;
  try {
    const check = await ClientService.checkNameDuplicate(trimmed);
    if (!check.exists) return true;
    const displayName = (check.name || trimmed).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return confirmAlert({
      title: 'Account already exists',
      message: `An account named '${displayName}' already exists. Continue anyway?`,
      confirmLabel: 'Continue',
      confirmClass: 'btn-primary',
    });
  } catch (err) {
    console.warn('Account name duplicate check failed; proceeding with create:', err);
    return true;
  }
}
